var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temItens
    ? _c(
        "div",
        { staticClass: "sugestoes-de-exemplo" },
        _vm._l(_vm.itens, function(item) {
          return _c(
            "button",
            {
              key: item.chave,
              staticClass: "sugestoes-de-exemplo__linha",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.usar(item.prompt)
                }
              }
            },
            [
              _c("icon-svg", {
                staticClass: "sugestoes-de-exemplo__icone",
                attrs: { name: item.icone, size: 15, color: "currentColor" }
              }),
              _c(
                "span",
                { staticClass: "sugestoes-de-exemplo__titulo ia-texto-corpo" },
                [_vm._v(_vm._s(item.titulo))]
              ),
              item.descricao
                ? _c(
                    "span",
                    {
                      staticClass:
                        "sugestoes-de-exemplo__descricao ia-texto-auxiliar"
                    },
                    [_vm._v(_vm._s(item.descricao))]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }